<template>
  <div class="carousel">
    <div :class="['carousel-page', current === index ? ' active' : '']" :style="{transform: `translate3d(${position(index) * 100}%, 0, 0)`}" v-for="(image, index) in imgItems" :key="index">
      <div class="carousel-item">
        <img :src="image" alt="">
        <button class="emd-btn _color_danger _size_small button_slide_delete" type="button" name="button" :disabled="disabled" @click="deleteImage(index)">{{$t('edit.form.images.delete')}}</button>
      </div>
      <button class="o-arrow-prev" v-show="imgItems.length > 1" @click="decreaseCurrent"></button>
      <button class="o-arrow-next" v-show="imgItems.length > 1" @click="increaseCurrent"></button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Carousel',
  props: {
    images: {
      type: Array,
      required: false,
      default: function () {
        return []
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      current: 0
    }
  },
  computed: {
    imgItems: function () {
      return this.images
    }
  },
  methods: {
    decreaseCurrent: function () {
      this.current += this.imgItems.length - 1
      this.current %= this.imgItems.length
    },
    increaseCurrent: function () {
      this.current += 1
      this.current %= this.imgItems.length
    },
    position: function (index) {
      if (index === this.current) return 0
      if (index === (this.current + 1) % this.imgItems.length) return 1
      return -1
    },
    deleteImage (index) {
      this.current = this.current === 0 ? this.current : --this.current
      this.$emit('deleteImage', index)
    }
  }
}
</script>
<style>
  .carousel {
    height: 100%;
    margin: auto;
    position: relative;
    overflow: hidden;
  }
  .carousel-item {
    height: 100%;
  }
  .carousel-item img {
    height: 100%;
    object-fit: cover;
    width: 100%;
  }
  .carousel-page {
    visibility: hidden;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    transition: 0.5s;
    height: 100%;
    border: 1px solid #EEE;
  }

  .carousel-page.active {
    visibility: visible;
    position: static;
  }
  .o-arrow-prev,
  .o-arrow-next {
      position: absolute;
      top: 50%;
      transform: translate(0, -50%);
      display: block;
      width: 50px;
      height: 50px;
      border: 0;
      background: transparent;
      color: #fff;
      cursor: pointer;
      outline: none;
  }

  .o-arrow-next {
    right: 5px;
    border: solid transparent;
    border-width: 20px 20px 0 0;
    box-shadow: -1px 1px 0 0 #178176 inset;
    transform: rotate(45deg);
  }
  .o-arrow-next:hover {
    box-shadow: -1px 1px 0 0 #082558 inset;
  }
  .o-arrow-prev {
    left: 5px;
    border: solid transparent;
    border-width: 0px 0px 20px 20px;
    box-shadow: 1px -1px 0 0 #178176 inset;
    transform: rotate(45deg);
  }
  .o-arrow-prev:hover {
    box-shadow: 1px -1px 0 0 #082558 inset
  }

  .button_slide_delete {
     position: absolute;
     z-index: 999;
     left: 20px;
     top: 20px;
  }

</style>
